/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UserRoleDTO
 */
export interface UserRoleDTO {
  /**
   *
   * @type {number}
   * @memberof UserRoleDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof UserRoleDTO
   */
  name: string;
}

/**
 * Check if a given object implements the UserRoleDTO interface.
 */
export function instanceOfUserRoleDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;

  return isInstance;
}

export function UserRoleDTOFromJSON(json: any): UserRoleDTO {
  return UserRoleDTOFromJSONTyped(json, false);
}

export function UserRoleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRoleDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"]
  };
}

export function UserRoleDTOToJSON(value?: UserRoleDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name
  };
}
